function tryGetNumber(val, defaultVal) {
  if (val === undefined || val === '') {
    return defaultVal;
  }

  var num = parseInt(val, 10);
  return isFinite(num) ? num : defaultVal; // parseInt returns NaN
}

export { tryGetNumber };